export const ATTENDANCE_PERMISSIONS = {
  DAILY_DASHBOARD_VIEW: 'attendance.daily_dashboard.view',
  DAILY_DASHBOARD_EXPORT: 'attendance.daily_dashboard.export',
  JOB_CARD_VIEW: 'attendance.job_card.view',
  JOB_CARD_EXPORT: 'attendance.job_card.export',
  SHIFT_JOB_CARD_VIEW: 'attendance.shift_job_card.view',
  SHIFT_JOB_CARD_EXPORT: 'attendance.shift_job_card.export',
} as const;

export const RBAC_PERMISSIONS = {
  USER_ALL_VIEW: 'user.all.view',
  USER_ADMIN_VIEW: 'user.admin.view',
  USER_AGENT_VIEW: 'user.agent.view',
  USER_GENERAL_VIEW: 'user.general.view',
  USER_MARKETING_VIEW: 'user.marketing.view',
  USER_SPECIAL_VIEW: 'user.special.view',
  USER_CREATE: 'user.create',
  USER_EDIT: 'user.edit',
  USER_DELETE: 'user.delete',
  USER_CHANGE_PASSWORD: 'user.change_password',
  USER_ROLES_VIEW: 'user.roles.view',
  USER_ROLES_EDIT: 'user.roles.edit',
  USER_PERMISSION_EDIT: 'user.permission.edit',
  ROLE_VIEW: 'role.view',
  ROLE_CREATE: 'role.create',
  ROLE_EDIT: 'role.edit',
  ROLE_DELETE: 'role.delete',
  ROLE_PERMISSION_EDIT: 'role.permission.edit',
  INSTITUTE_MAPPING_VIEW: 'institute_mapping.view',
  INSTITUTE_MAPPING_CREATE: 'institute_mapping.create',
  INSTITUTE_MAPPING_DELETE: 'institute_mapping.delete',
} as const;

export const BILLING_PERMISSIONS = {
  OFFLINE_DCR_VERIFY_VIEW: 'billing.offline_dcr_verify.view',
  OFFLINE_DCR_VERIFY_VERIFY: 'billing.offline_dcr_verify.verify',
  OFFLINE_DER_VERIFY_VIEW: 'billing.offline_der_verify.view',
  OFFLINE_DER_VERIFY_VERIFY: 'billing.offline_der_verify.verify',
  EXPENSE_APPROVAL_VIEW: 'billing.expense_approval.view',
  EXPENSE_APPROVAL_APPROVE: 'billing.expense_approval.approve',
  DCR_APPROVE_VIEW: 'billing.dcr_approve.view',
  APPROVAL_VIEW: 'billing.approval.view',
  APPROVAL_APPROVE: 'billing.approval.approve',
  ALL_COST_VIEW: 'billing.all_cost.view',
  COST_AMENDMENT_AMEND: 'billing.cost_amendment.amend',
  WEB_EXPENSES_CREATE: 'billing.web_expenses.create',
} as const;

export const INSTITUTE_PERMISSIONS = {
  VIEW: 'institute.list.view',
  CREATE: 'institute.list.create',
  EDIT: 'institute.list.edit',
  DELETE: 'institute.list.delete',
} as const;

export const FIELD_OPS_PERMISSIONS = {
  LEAVE_VIEW: 'leave.applications.view',
  LEAVE_REVIEW: 'leave.applications.review',
  INSTITUTE_SUBMISSION_VIEW: 'institute_submission.submissions.view',
  INSTITUTE_SUBMISSION_REVIEW: 'institute_submission.submissions.review',
  TEACHER_VIEW: 'teacher.submissions.view',
  FEEDBACK_VIEW: 'feedback.list.view',
  FEEDBACK_MANAGE: 'feedback.list.manage',
  SURVEY_VIEW: 'survey.list.view',
  SURVEY_CREATE: 'survey.list.create',
  SURVEY_EDIT: 'survey.list.edit',
} as const;

export const MO_TRAVEL_PERMISSIONS = {
  VIEW: 'mo_travel.travel_history.view',
} as const;

export const MARKET_PROMOTION_PERMISSIONS = {
  DISTRIBUTION_SUMMARY_VIEW: 'market_promotion.distribution_summary.view',
  REGION_SUMMARY_VIEW: 'market_promotion.region_summary.view',
  ADJUSTMENT_VIEW: 'market_promotion.adjustment.view',
  APPROVAL_VIEW: 'market_promotion.approval.view',
  APPROVAL_EXPORT: 'market_promotion.approval.export',
  APPROVAL_APPROVE: 'market_promotion.approval.approve',
  MIS_APPROVAL_VIEW: 'market_promotion.mis_approval.view',
  MIS_APPROVAL_VERIFY: 'market_promotion.mis_approval.mis_verify',
  MIS_APPROVAL_EXPORT: 'market_promotion.mis_approval.export',
  APPROVAL_REPORT_VIEW: 'market_promotion.approval_report.view',
  PROJECT_VIEW: 'market_promotion.project.view',
  PROJECT_CREATE: 'market_promotion.project.create',
  PROJECT_EDIT: 'market_promotion.project.edit',
  BUDGET_VIEW: 'market_promotion.budget.view',
  BUDGET_CREATE: 'market_promotion.budget.create',
  BUDGET_EDIT: 'market_promotion.budget.edit',
  PUBLISH_PANEL_VIEW: 'market_promotion.publish_panel.view',
  PUBLISH_PANEL_EXPORT: 'market_promotion.publish_panel.export',
  PUBLISH_PANEL_CREATE: 'market_promotion.publish_panel.create',
  PUBLISH_PANEL_CONFIRM: 'market_promotion.publish_panel.confirm',
  ACCOUNTS_ADJUST_VIEW: 'market_promotion.accounts_adjust.view',
  ACCOUNTS_ADJUST_EXPORT: 'market_promotion.accounts_adjust.export',
  ACCOUNTS_ADJUST_DISBURSE: 'market_promotion.accounts_adjust.disburse',
  REQUISITION_VIEW: 'market_promotion.requisition.view',
  REQUISITION_CREATE: 'market_promotion.requisition.create',
  REQUISITION_EDIT: 'market_promotion.requisition.edit',
  CASH_COLLECTION_VIEW: 'market_promotion.cash_collection.view',
  CASH_COLLECTION_EXPORT: 'market_promotion.cash_collection.export',
} as const;

export const PRODUCT_PERMISSIONS = {
  SPECIMEN_LIST_VIEW: 'product.specimen_list.view',
  SPECIMEN_LIST_EXPORT: 'product.specimen_list.export',
  SPECIMEN_LIST_CREATE: 'product.specimen_list.create',
  SPECIMEN_LIST_EDIT: 'product.specimen_list.edit',
  SPECIMEN_LIST_DELETE: 'product.specimen_list.delete',
  SPECIMEN_LIST_VIEW_VIEW: 'product.specimen_list_view.view',
  BOOK_TYPE_VIEW: 'product.book_type.view',
  BOOK_TYPE_CREATE: 'product.book_type.create',
  BOOK_TYPE_EDIT: 'product.book_type.edit',
  BOOK_TYPE_DELETE: 'product.book_type.delete',
  BOOK_EDITION_VIEW: 'product.book_edition.view',
  BOOK_EDITION_CREATE: 'product.book_edition.create',
  BOOK_EDITION_EDIT: 'product.book_edition.edit',
  BOOK_EDITION_DELETE: 'product.book_edition.delete',
  SPECIMEN_DISTRIBUTION_VIEW: 'product.specimen_distribution.view',
  SPECIMEN_DISTRIBUTION_EXPORT: 'product.specimen_distribution.export',
  SPECIMEN_ADJUSTMENT_VIEW: 'product.specimen_adjustment.view',
  SPECIMEN_INSTITUTION_VIEW: 'product.specimen_institution.view',
  SPECIMEN_INSTITUTION_EXPORT: 'product.specimen_institution.export',
  SPECIMEN_INSTITUTION_EDIT: 'product.specimen_institution.edit',
  DCR_SHEET_VIEW: 'product.dcr_sheet.view',
  DCR_DATE_TO_DATE_VIEW: 'product.dcr_date_to_date.view',
  SPECIMEN_REQUISITION_VIEW: 'product.specimen_requisition.view',
  SPECIMEN_REQUISITION_EDIT: 'product.specimen_requisition.edit',
  SPECIMEN_REQUISITION_REVIEW_VIEW: 'product.specimen_requisition_review.view',
  SPECIMEN_REQUISITION_REVIEW_REVIEW: 'product.specimen_requisition_review.review',
  SP_PROMO_REQUISITION_VIEW: 'product.sp_promo_requisition.view',
  BOOKLISTED_INSTITUTE_VIEW: 'product.booklisted_institute.view',
  BOOKLISTED_INSTITUTE_EDIT: 'product.booklisted_institute.edit',
  BOOKLISTED_INSTITUTE_REVIEW: 'product.booklisted_institute.review',
  STUDENT_PROJECT_VIEW: 'product.student_project.view',
  STUDENT_PROJECT_CREATE: 'product.student_project.create',
  STUDENT_PROJECT_EDIT: 'product.student_project.edit',
  STUDENT_PROJECT_DELETE: 'product.student_project.delete',
} as const;

export const PROMOTION_PERMISSIONS = {
  ADJUSTMENT_VIEW: 'promotion.adjustment.view',
  DISTRIBUTION_VIEW: 'promotion.distribution.view',
  ITEM_LIST_VIEW: 'promotion.item_list.view',
  ITEM_LIST_CREATE: 'promotion.item_list.create',
  ITEM_LIST_EDIT: 'promotion.item_list.edit',
  ITEM_LIST_DELETE: 'promotion.item_list.delete',
  ITEM_TYPE_VIEW: 'promotion.item_type.view',
  ITEM_TYPE_CREATE: 'promotion.item_type.create',
  ITEM_TYPE_EDIT: 'promotion.item_type.edit',
  ITEM_TYPE_DELETE: 'promotion.item_type.delete',
} as const;

export const PUBLISH_PERMISSIONS = {
  SALES_VIEW: 'publish.sales.view',
  SALES_EXPORT: 'publish.sales.export',
  SALES_CREATE: 'publish.sales.create',
  MIS_VIEW: 'publish.mis.view',
  MIS_EXPORT: 'publish.mis.export',
  MIS_CONFIRM: 'publish.mis.confirm',
  ACCOUNTS_VIEW: 'publish.accounts.view',
  ACCOUNTS_EXPORT: 'publish.accounts.export',
  ACCOUNTS_DISBURSE: 'publish.accounts.disburse',
} as const;

export const QUESTION_PERMISSIONS = {
  DOWNLOAD_BY_CLASS_VIEW: 'question.download_by_class.view',
  DOWNLOAD_BY_BOARD_VIEW: 'question.download_by_board.view',
  DOWNLOAD_VIEW: 'question.download.view',
  UPLOAD_VIEW: 'question.upload.view',
  UPLOAD_CREATE: 'question.upload.create',
  UPLOAD_RESET: 'question.upload.reset',
  UPLOAD_DOWNLOAD: 'question.upload.download',
  PROJECT_VIEW: 'question.project.view',
  PROJECT_CREATE: 'question.project.create',
  PROJECT_EDIT: 'question.project.edit',
  PROJECT_DELETE: 'question.project.delete',
  PROJECT_ASSIGN: 'question.project.assign',
  SUBJECT_VIEW: 'question.subject.view',
  SUBJECT_CREATE: 'question.subject.create',
  SUBJECT_EDIT: 'question.subject.edit',
  SUBJECT_DELETE: 'question.subject.delete',
} as const;

export const REPORT_PERMISSIONS = {
  SYSTEM_DASHBOARD_VIEW: 'report.system_dashboard.view',
  SYSTEM_DASHBOARD_EXPORT: 'report.system_dashboard.export',
  DCR_DASHBOARD_VIEW: 'report.dcr_dashboard.view',
  DCR_DASHBOARD_EXPORT: 'report.dcr_dashboard.export',
  DER_DASHBOARD_VIEW: 'report.der_dashboard.view',
  DER_DASHBOARD_EXPORT: 'report.der_dashboard.export',
  PENDING_VIEW: 'report.pending.view',
  ZONAL_STATEMENT_VIEW: 'report.zonal_statement.view',
  DCR_SUMMARY_EXPORT: 'report.dcr_summary.export',
  APP_VERSION_VIEW: 'report.app_version.view',
} as const;

export const SETTINGS_PERMISSIONS = {
  LIMIT_TYPES_EDIT: 'settings.limit_types.edit',
  MENU_LABELS_EDIT: 'settings.menu_labels.edit',
  WEB_URLS_CREATE: 'settings.web_urls.create',
  WEB_URLS_EDIT: 'settings.web_urls.edit',
  WEB_URLS_DELETE: 'settings.web_urls.delete',
  INSTITUTE_TYPES_CREATE: 'settings.institute_types.create',
  INSTITUTE_TYPES_EDIT: 'settings.institute_types.edit',
  INSTITUTE_TYPES_DELETE: 'settings.institute_types.delete',
  LEAVE_TYPES_CREATE: 'settings.leave_types.create',
  LEAVE_TYPES_EDIT: 'settings.leave_types.edit',
  LEAVE_TYPES_DELETE: 'settings.leave_types.delete',
  FEEDBACK_TYPES_CREATE: 'settings.feedback_types.create',
  FEEDBACK_TYPES_EDIT: 'settings.feedback_types.edit',
  FEEDBACK_TYPES_DELETE: 'settings.feedback_types.delete',
  SUBJECTS_CREATE: 'settings.subjects.create',
  SUBJECTS_EDIT: 'settings.subjects.edit',
  SUBJECTS_DELETE: 'settings.subjects.delete',
  TEACHER_DESIGNATIONS_CREATE: 'settings.teacher_designations.create',
  TEACHER_DESIGNATIONS_EDIT: 'settings.teacher_designations.edit',
  TEACHER_DESIGNATIONS_DELETE: 'settings.teacher_designations.delete',
} as const;

export const ALL_PERMISSIONS = [
  ...Object.values(ATTENDANCE_PERMISSIONS),
  ...Object.values(RBAC_PERMISSIONS),
  ...Object.values(BILLING_PERMISSIONS),
  ...Object.values(INSTITUTE_PERMISSIONS),
  ...Object.values(FIELD_OPS_PERMISSIONS),
  ...Object.values(MO_TRAVEL_PERMISSIONS),
  ...Object.values(MARKET_PROMOTION_PERMISSIONS),
  ...Object.values(PRODUCT_PERMISSIONS),
  ...Object.values(PROMOTION_PERMISSIONS),
  ...Object.values(PUBLISH_PERMISSIONS),
  ...Object.values(QUESTION_PERMISSIONS),
  ...Object.values(REPORT_PERMISSIONS),
  ...Object.values(SETTINGS_PERMISSIONS),
] as const;

export type PermissionCode = (typeof ALL_PERMISSIONS)[number];
